import moment from 'moment';
import { ApiResponse, Service } from 'src/common';
import { Pagination } from 'src/common/core/pagination';
import { api } from 'src/common/infra';

import { DriversDTO, DriversRequest } from '../dtos/drivers.dtos';

export class DriversPagedService implements Service<DriversRequest, Pagination<DriversDTO>> {
    public async execute(data: DriversRequest) {
        const { dateFrom, dateTo, events, regions, countries, operationsFiltered, pageSize, start, operations } = data;
        const {
            data: { content },
        } = await api.get<ApiResponse<Pagination<DriversDTO>>>('/analytics/drivers/paginated', {
            params: {
                dateFrom: moment(dateFrom).format('YYYY-MM-DD'),
                dateTo: moment(dateTo).format('YYYY-MM-DD'),
                events,
                regions,
                countries,
                size: pageSize,
                start,
                operationsFiltered,
                operations,
            },
        });

        return content;
    }

}

export const driversPagedService = new DriversPagedService();
